import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  GET,
} from '@app/core/api';

import { BootstrapResult } from '@app/core/types/bootstrap-result.interface';


@ApiController('api/app')
@Injectable({
  providedIn: 'root',
})
export class AppBootstrapApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('/bootstrapper')
  getBootstrap(): Observable<ApiResponse<BootstrapResult>> {
    return {} as Observable<ApiResponse<BootstrapResult>>;
  }
}
